document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.show-hide-description a.read-more-btn');
    if (!btn) return;
    e.preventDefault();
    const parent = btn.closest('.show-hide-description');
    parent.classList.toggle('show-active');

    btn.textContent = parent.classList.contains('show-active')
      ? 'Lees minder'
      : 'Lees meer';
  });

});